import * as api from 'api';
import { message } from 'antd';

export async function quickDownloadOssFile(filePath) {
	const filename = filePath.split('/').pop();
	await downloadFile('default', { ossKey: filePath, filename });
}
export async function downloadFile(appId, record) {
	try {
		const response = await api.previewFile(appId, record.ossKey);

		const fileName = record.filename || '未知文件.pdf';
		const blob = new Blob([response], {
			type: 'application/pdf', // 明确指定 PDF 类型，确保浏览器识别
		});
		const isPdf =
			record.type === 'pdf' ||
			(record.type && record.type.includes('pdf')) ||
			record.filename.toLowerCase().endsWith('.pdf');

		if (isPdf) {
			const url = window.URL.createObjectURL(blob);

			const htmlContent = `
          <!DOCTYPE html>
          <html>
          <head>
            <meta charset="UTF-8">
            <title>${fileName}</title>
            <style>
              body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
              .header-container {
                background: #f5f5f5;
                padding: 15px 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #ddd;
                position: sticky;
                top: 0;
                z-index: 100;
              }
              .filename-header { 
                font-size: 16px;
                color: #333;
                font-weight: 500;
                flex: 1;
              }
              .chrome-filename-header{
               background:#3c3c3c;
                font-size: 14px;
                color: #666;
                font-weight: 400;
                color:#fff;
                position: absolute;
                top: 50px;
                left: 45px;
                z-index: 1000;
              }
              .download-btn {
                background:rgb(12, 12, 12);
                color: white;
                border: none;
                padding: 8px 16px;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
                display: flex;
                align-items: center;
                gap: 5px;
                position: absolute;
                top: 70px;
                right: 25px;
                z-index: 1000;
              }
              .download-btn:hover {
                background:rgb(42, 43, 44);
              }
              .download-btn:active {
                background:rgb(24, 25, 25);
              }
              
              /* 浏览器特定的样式 */
              .browser-edge {
                background:#f4f4f4;
                top: 59px;
                right: 40px;
                height:30px;
                width:30px;
                color:#000;
                font-size: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight:100;
              }
              .browser-edge:hover {
                background:#dcdcdc;
              }
              .browser-chrome {
                background:#3c3c3c;
                color:#fff;
                top: 44px;
                right: 89px;
                height:30px;
                width:30px;
                border-radius:50%;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .browser-chrome:hover {
                background:#5c5c5c;
              }
              .browser-safari {
                background:rgb(0, 112, 201);
                border-radius: 8px;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
              }
              .browser-safari:hover {
                background:rgb(0, 92, 181);
              }
              .browser-firefox {
                background:rgb(255, 149, 0);
                color: #000;
                font-weight: 500;
              }
              .browser-firefox:hover {
                background:rgb(235, 129, 0);
              }
              .browser-other {
                background:rgb(96, 96, 96);
                border: 1px solid rgb(128, 128, 128);
              }
              .browser-other:hover {
                background:rgb(128, 128, 128);
              }
              .pdf-container { 
                width: 100%; 
                height: calc(100vh - 70px); 
              }
              .pdf-viewer { 
                width: 100%; 
                height: 100%; 
                border: none; 
              }
              .browser-icon {
                width: 16px;
                height: 16px;
              }
function downloadPDF() {
  let downloadUrl;
  let isNewUrl = false;
  
  if (pdfBlobData) {
    // 使用缓存的Blob数据创建新的URL
    downloadUrl = window.URL.createObjectURL(pdfBlobData);
    isNewUrl = true;
    console.log('使用缓存数据创建新下载链接');
  } else {
    // 回退到原始URL
    downloadUrl = '${url}';
    console.log('使用原始下载链接');
  }
  
  // 创建下载链接并触发下载
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = '${fileName}';
  link.click();
  
  // 清理新的URL（延迟2秒）
  if (isNewUrl) {
    setTimeout(() => {
      window.URL.revokeObjectURL(downloadUrl);
    }, 2000);
  }
}            </style>
          </head>
          <body>
            <div class="header-container">
              <div class="filename-header" id="filename-header">${fileName}</div>
              <!-- Safari提示信息 -->
              <div id="safari-notice" style="display: none; background: #fff3cd; border: 1px solid #ffeaa7; padding: 8px 12px; border-radius: 4px; color: #856404; font-size: 12px; margin-left: 15px;">
                Safari用户：如无法预览，请点击下载按钮获取文件
              </div>
            </div>
            <button class="download-btn" onclick="downloadPDF()" title="下载PDF文件">
              <span id="download-text">⬇</span>
            </button>
            <div class="pdf-container" id="pdf-container">
              <!-- Safari将使用iframe，其他浏览器使用embed -->
              <script>
                // Safari安全策略处理
                if (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1) {
                  // Safari使用iframe
                  document.write('<iframe src="${url}" type="application/pdf" class="pdf-viewer" style="width: 100%; height: 100%; border: none;"></iframe>');
                } else {
                  // 其他浏览器使用embed
                  document.write('<embed src="${url}" type="application/pdf" class="pdf-viewer" />');
                }
              </script>
            </div>
            
            <script>
              function detectBrowser() {
                const userAgent = navigator.userAgent;
                if (userAgent.indexOf('Edg') > -1) return 'edge';
                if (userAgent.indexOf('Chrome') > -1) return 'chrome';
                if (userAgent.indexOf('Safari') > -1) return 'safari';
                if (userAgent.indexOf('Firefox') > -1) return 'firefox';
                return 'other';
              }
              function updateDownloadButton() {
                const browser = detectBrowser();
                const downloadBtn = document.querySelector('.download-btn');
                const textElement = document.getElementById('download-text');
                const safariNotice = document.getElementById('safari-notice');
                const filenameHeader = document.getElementById('filename-header');
                downloadBtn.classList.remove('browser-edge', 'browser-chrome', 'browser-safari', 'browser-firefox', 'browser-other');
                if (browser === 'edge') {
                  downloadBtn.classList.add('browser-edge');
                  downloadBtn.title = 'Microsoft Edge - 保存PDF文件';
                  if (safariNotice) safariNotice.style.display = 'none';
                  if (filenameHeader) filenameHeader.classList.remove('chrome-filename-header', 'safari-filename-header', 'firefox-filename-header', 'other-filename-header');
                } else if (browser === 'chrome') {
                  downloadBtn.classList.add('browser-chrome');
                  downloadBtn.title = 'Google Chrome - 下载PDF文件';
                  if (safariNotice) safariNotice.style.display = 'none';
                  if (filenameHeader) {
                    filenameHeader.classList.remove('safari-filename-header', 'firefox-filename-header', 'edge-filename-header', 'other-filename-header');
                    filenameHeader.classList.add('chrome-filename-header');
                  }
                } else if (browser === 'safari') {
                  downloadBtn.classList.add('browser-safari');
                  downloadBtn.title = 'Apple Safari - 下载PDF文件';
                  if (safariNotice) safariNotice.style.display = 'block';
                  if (filenameHeader) filenameHeader.classList.remove('chrome-filename-header', 'firefox-filename-header', 'edge-filename-header', 'other-filename-header');
                } else if (browser === 'firefox') {
                  downloadBtn.classList.add('browser-firefox');
                  downloadBtn.title = 'Mozilla Firefox - 下载PDF文件';
                  if (safariNotice) safariNotice.style.display = 'none';
                  if (filenameHeader) filenameHeader.classList.remove('chrome-filename-header', 'safari-filename-header', 'edge-filename-header', 'other-filename-header');
                } else {
                  downloadBtn.classList.add('browser-other');
                  downloadBtn.title = '下载PDF文件';
                  if (safariNotice) safariNotice.style.display = 'none';
                  if (filenameHeader) filenameHeader.classList.remove('chrome-filename-header', 'safari-filename-header', 'firefox-filename-header', 'edge-filename-header');
                }
              }
              function cachePdfBlobData() {
                try {
                  // Safari安全策略：不直接访问iframe内容
                  if (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1) {
                    console.log('Safari浏览器：跳过Blob缓存以避免安全限制');
                    return;
                  }
                  
                  const embed = document.querySelector('embed[type="application/pdf"]');
                  if (embed && embed.src && embed.src.startsWith('blob:')) {
                    fetch(embed.src)
                      .then(response => response.blob())
                      .then(blob => {
                        window.pdfBlobData = blob;
                        console.log('PDF Blob数据已缓存，支持多次下载');
                      })
                      .catch(error => {
                        console.log('缓存PDF数据失败:', error);
                      });
                  }
                } catch (error) {
                  console.log('缓存PDF数据时出错:', error);
                }
              }
              
              function downloadPDF() {
                let downloadUrl;
                let isNewUrl = false;
                
                // 检查是否有缓存的Blob数据
                if (window.pdfBlobData) {
                  downloadUrl = window.URL.createObjectURL(window.pdfBlobData);
                  isNewUrl = true;
                  console.log('使用缓存数据创建新下载链接');
                } else {
                  downloadUrl = '${url}';
                  console.log('使用原始下载链接');
                }
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = '${fileName.replace(/'/g, "\\'")}';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                if (isNewUrl) {
                  setTimeout(() => {
                    window.URL.revokeObjectURL(downloadUrl);
                    console.log('已清理临时下载链接');
                  }, 2000);
                }
              }
              updateDownloadButton();
              setTimeout(() => {
                cachePdfBlobData();
              }, 1000);
            </script>
          </body>
          </html>
        `;
			const newTab = window.open('about:blank', '_blank');
			if (newTab) {
				// Safari特殊处理 - 延迟写入内容
				if (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1) {
					// Safari需要特殊处理，先写入基本结构再填充内容
					newTab.document.open();
					newTab.document.write(htmlContent);
					setTimeout(() => {
						newTab.document.close();
					}, 100);
				} else {
					newTab.document.write(htmlContent);
					newTab.document.close();
				}
			} else {
				const link = document.createElement('a');
				link.href = url;
				link.download = fileName || 'document.pdf';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				message.warning('弹窗被阻止，已为您直接下载文件');
			}

			setTimeout(() => {
				try {
					window.URL.revokeObjectURL(url);
				} catch (e) {
					console.log('Blob URL已清理或失效');
				}
			}, 300000);
		} else {
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', record.filename);
			document.body.appendChild(link);
			link.click();
			setTimeout(() => {
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			}, 100);
			message.success('File downloaded successfully');
		}
	} catch (error) {
		console.error('下载文件失败：', error);
	}
}
